import { ReactSVG } from "react-svg";
import { CalculationResultCardProps } from "./types";
import { Alert } from "ui/components/Alert";

const CalculationResultCard: React.FC<CalculationResultCardProps> = (props) => {
  const { calculationId } = props;

  return (
    <>
      <div className="text-center flex items-center justify-center my-6 mx-auto">
        <div>
          <ReactSVG
            src={"/media/images/success.svg"}
            className="mx-auto w-fit mb-10"
          />
          <p className="text-slate-500 font-bold mb-2">Odlično!</p>
          <h2 className="text-2xl  font-bold opacity-90 mb-4">
            Čestitamo! Uspješno ste zatražili ponudu!
          </h2>
          <Alert title="Daljnje upute" message="Na email adresu sa kojom ste se prijavili u sustav.." variant="success" />
          <p className="text-sm">
            <strong className="uppercase">Broj Rezervacije:</strong>123456789
          </p>
        </div>
      </div>
    </>
  );
};
export default CalculationResultCard;
